import { handle400Statuses, sendApiRequest } from '@services/api';
import { logNetRequest } from '@utils/usefulFuncs';

const LIST_URL = 'v2/genai/data_analyst_agent/sessions';

export const fetchDataAnalystAgentSessions = async () => {
  const { status, data, error } = await sendApiRequest('get', LIST_URL);
  logNetRequest(LIST_URL, status, data, error);
  handle400Statuses(status);

  if (status === 200 && data && Array.isArray(data.data_analyst_agent_sessions)) {
    return { status, sessions: data.data_analyst_agent_sessions, error: null };
  }
  return { status, sessions: [], error: error || data?.error || null };
};

export const fetchDataAnalystAgentSession = async (id) => {
  const url = `${LIST_URL}/${id}`;
  const { status, data, error } = await sendApiRequest('get', url);
  logNetRequest(url, status, data, error);
  handle400Statuses(status);

  if (status === 200 && data && data.data_analyst_agent_session) {
    return { status, session: data.data_analyst_agent_session, error: null };
  }
  return { status, session: null, error: error || data?.error || null };
};
